import useFormControls from '../../Monitor/components/OutreachConfigForm/hooks/useFormControls';
import { OutreachConfigGenericFormField } from '../../Monitor/types';
import React from 'react';

export type OutreachConfigFieldMessagesProps<T extends any> = {
  propertyName: OutreachConfigGenericFormField<T>['name'];
} & Omit<OutreachConfigGenericFormField<T>, 'name'>;

function OutreachConfigFieldMessages<T extends any>({
  field,
  form,
  propertyName,
}: OutreachConfigFieldMessagesProps<T>) {
  const { renderErrorMessage } = useFormControls<T>(field, form);
  const messages = renderErrorMessage(propertyName as keyof T);

  return (
    <div className="OutreachContainer__subscriber-outreach-trigger-field-messages">
      {messages.map((message, index) => (
        <span key={index} className="color-status-error">
          {message.message}
        </span>
      ))}
    </div>
  );
}

export default OutreachConfigFieldMessages;
